// extracted by mini-css-extract-plugin
export default {"page":"page___cb79f5fd25c184c820e8","visible":"visible___fc0d5f4bde4f390f814b","header":"header___cad589f1a3076ee57e23","btn":"btn___ef2edc9785b8afdb0fb3"};